export default "__VITE_ASSET__MTIpOQtW__"